var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenRoundTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95052 0.666748C4.90043 0.666748 1.61719 3.94999 1.61719 8.00008C1.61719 12.0502 4.90043 15.3334 8.95052 15.3334C13.0006 15.3334 16.2839 12.0502 16.2839 8.00008C16.2839 3.94999 13.0006 0.666748 8.95052 0.666748ZM12.4219 6.47149C12.6823 6.21114 12.6823 5.78903 12.4219 5.52868C12.1616 5.26833 11.7395 5.26833 11.4791 5.52868L7.95052 9.05727L6.42193 7.52868C6.16158 7.26833 5.73947 7.26833 5.47912 7.52868C5.21877 7.78903 5.21877 8.21114 5.47912 8.47149L7.47912 10.4715C7.73947 10.7318 8.16158 10.7318 8.42193 10.4715L12.4219 6.47149Z",
    fill: "#19D3C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRoundTick);
export default __webpack_public_path__ + "static/media/green-round-tick.ca50872fe891d1242b0feb0db48ffed2.svg";
export { ForwardRef as ReactComponent };